import { HTTP_STATUSES } from "@miplatform/constants";
import { toastService } from "@miplatform/toast";
import { bugsnag } from "@miplatform/utils";
import { extractErrorMessage } from "../extractErrorMessage";

export const reportError = (error, request, toastFailureConfig) => {
  const errorBody = extractErrorMessage(error);

  const errorObj = {
    request: error?.response?.request,
    message: error?.response?.data?.errorBody || errorBody,
    endpoint: request?.url,
    headers: error?.response?.headers,
    error: true,
    code: error?.code,
    status: error?.response?.status,
    errorBody,
    timestamp: new Date().toISOString(),
  };

  if (process.env.NODE_ENV !== "production") {
    console.error("Network Error: ", errorObj);
  }

  if (errorObj.status === HTTP_STATUSES.FORBIDDEN) {
    toastService.error({
      text: "You do not have the required permissions to perform this action.",
    });
  }

  if (
    (errorObj.status >= HTTP_STATUSES.BAD_REQUEST &&
      errorObj.status !== HTTP_STATUSES.UNAUTHORIZED &&
      errorObj.status !== HTTP_STATUSES.FORBIDDEN) ||
    toastFailureConfig
  ) {
    toastService.error({
      text: `${
        toastFailureConfig?.text ? `${toastFailureConfig.text} ` : ""
      }${errorBody}`,
    });
  }

  bugsnag.notify(
    new Error(`Error Request: ${JSON.stringify(errorObj, null, 2)}`)
  );

  return errorObj;
};
